import { GameTabs, type GameId } from "plos/src/components/GameTabs";
import { useTranslation } from "react-i18next";
import { useTrackingContext } from "../../contexts/TrackingContext";
import headlineLogo from "../../img/headline-logo.svg";
import { getPlayerComp } from "../../utils/player-comps";
import {
  gameHeaderContainerStyles,
  gameHeaderLogoStyles,
  gameHeaderStyles,
  gameTabContainer,
  playerLockupStyles,
} from "./GameHeader.css";
import Nav from "./Nav";

const NavEventDetails: Record<GameId, string> = {
  classic: "Fantasy",
  challenge: "FPL Challenge",
  draft: "FPL Draft",
};

const GameHeader = () => {
  const { t } = useTranslation("home");
  const { fireClickTrackEvent } = useTrackingContext();

  const trackNavigationClick = (id: GameId) => {
    fireClickTrackEvent({
      event_component: "navigation click",
      event_category: "fantasy top navigation",
      event_detail: NavEventDetails[id],
    });
  };

  return (
    <header className={gameHeaderContainerStyles}>
      <div className={gameHeaderStyles}>
        <div className={gameTabContainer}>
          <h1>
            <img
              src={headlineLogo}
              className={gameHeaderLogoStyles}
              alt={t("headlineLogoAlt", "Fantasy Premier League")}
            />
          </h1>
          <GameTabs activeGame="classic" onTabPress={trackNavigationClick} />
        </div>
        <img
          src={getPlayerComp().x1}
          srcSet={`${getPlayerComp().x1} 1x, ${getPlayerComp().x2} 2x`}
          alt={t("playerImagesAlt", "Player images")}
          className={playerLockupStyles}
        />
      </div>
      <Nav />
    </header>
  );
};

export default GameHeader;
